export type LanguageCode = 'de' | 'en' | 'nl' | 'pl';

type Language = {
	code: LanguageCode;
	file: `${LanguageCode}.ts`;
};

const languages: Language[] = [
	{
		code: 'de',
		file: 'de.ts',
	},
	{
		code: 'en',
		file: 'en.ts',
	},
	{
		code: 'nl',
		file: 'nl.ts',
	},
	{
		code: 'pl',
		file: 'pl.ts',
	},
];

export default languages;
